import client from "./client";

const getBanks = () => client.get("/subsidiary/dashboard/banks");

export default { getBanks };
